import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

type SearchDialogEmptyProps = {
  variant: "empty" | "no-results";
};

export function SearchDialogEmpty({ variant }: SearchDialogEmptyProps) {
  const { t } = useTranslation();

  const isNoResults = variant === "no-results";

  return (
    <div className="flex flex-col items-center justify-center py-16 text-muted-foreground">
      <div
        className={`flex h-20 w-20 items-center justify-center rounded-full mb-4 ${
          isNoResults ? "bg-muted/50" : "bg-muted"
        }`}
      >
        <Search className={`h-10 w-10 ${isNoResults ? "opacity-50" : ""}`} />
      </div>
      <p className="text-sm">
        {t(isNoResults ? "search.noResults" : "search.empty")}
      </p>
    </div>
  );
}
